// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__-hash--base64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 97
// module chunks = 0